import React, { useRef, useCallback, useEffect, useState } from 'react'

const X_PADDING = 16

export const Range = ({
  min,
  max,
  value,
  onChange,
}: {
  min: number
  max: number
  value: number
  onChange: (newValue: number) => void
}) => {
  const [dragging, setDragging] = useState(false)

  const startDrag = useCallback(e => {
    e.preventDefault()
    setDragging(true)
  }, [])

  const endDrag = useCallback(() => {
    setDragging(false)
  }, [])

  const trackRef = useRef(null)
  const setTrackRef = useCallback(
    node => {
      if (node !== null) {
        node.addEventListener('touchstart', startDrag)
        node.addEventListener('mousedown', startDrag)
      }

      trackRef.current = node
    },
    [startDrag]
  )

  const move = useCallback(
    (e: MouseEvent | TouchEvent) => {
      const x =
        e instanceof MouseEvent ? e.clientX : e.changedTouches[0].clientX
      if (trackRef.current && dragging) {
        const rect = trackRef.current.getBoundingClientRect()
        const percent =
          (x - (rect.left + X_PADDING)) / (rect.width - X_PADDING * 2)
        const unclamped = Math.round(percent * (max - min) + min)
        const clamped = Math.max(Math.min(unclamped, max), min)
        onChange(clamped)
      }
    },
    [min, max, onChange, dragging]
  )

  useEffect(() => {
    window.addEventListener('mouseup', endDrag)
    window.addEventListener('mousemove', move)
    window.addEventListener('touchend', endDrag)
    window.addEventListener('touchmove', move)

    return () => {
      window.removeEventListener('mouseup', endDrag)
      window.removeEventListener('mousemove', move)
      window.removeEventListener('touchend', endDrag)
      window.removeEventListener('touchmove', move)
    }
  }, [endDrag, move])

  return (
    <div
      className="py-1 h-6"
      ref={setTrackRef}
      style={{
        position: 'relative',
        padding: `0 ${X_PADDING}px`,
      }}
    >
      <div className="relative">
        <div
          style={{
            background: '#eee',
            height: '0.25rem',
            position: 'relative',
            top: '0.375rem',
          }}
        />
        <div
          className="bg-charcoal"
          style={{
            position: 'absolute',
            top: '0',
            left: `${((value - min) / (max - min)) * 100}%`,
            width: '1rem',
            height: '1rem',
            borderRadius: '0.5rem',
            transform: 'translate(-50%, 0)',
          }}
        />
      </div>
    </div>
  )
}
